import React, { Component } from "react";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import MultiSelectDropdown from "../../components/dropdown/MultiSelectDropdown.js";
import ValidationText from "../../utils/validation/ValidationText.js";
import { CommonValidationMessages } from "../../utils/Messages.js";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DatePicker from "react-datepicker";
import moment from "moment";

class FinishProductLabelPrinting extends Component {
  constructor(props) {
    super(props);
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.state = {
      isPrintButtonHide: false,
      setLabelPrintingSlipModel: false,
      companyItemList: [],
      labelPrintingList: [],
      isLoading: false,
      labelDetails: {
        itemId: "",
        itemName: "",
        packing: "",
        batchNo: "",
        mfgDate: "",
        expDate: "",
        mrp: "",
        quantity: "",
        copy: "",
      },
      validState: {
        isValid: true,
        error: {},
      },
      validationRules: {
        itemId: [
          {
            type: "require",
            message: CommonValidationMessages.SelectRequired.replace(
              "{0}",
              "product name"
            ),
          },
        ],
        packing: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "packing"
            ),
          },
        ],
        batchNo: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "batch no"
            ),
          },
        ],
        mfgDate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "mfg. date"
            ),
          },
        ],
        expDate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "exp. Date"
            ),
          },
        ],
        mrp: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "MRP"
            ),
          },
        ],
        quantity: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "quantity"
            ),
          },
        ],
        copy: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "copy"
            ),
          },
        ],
      },
    };
  }

  componentDidMount() {
    this.getAllItem();
  }

  getAllItem = () => {
    this.commonServices.getAllItem().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.ItemName,
          value: item._id,
          packing: item.Packing,
        }));

        this.setState({ companyItemList: dropdownItems });
      } else {
        this.SwalServices.Error(
          response.Message
        );
      }
    });
  };
  isAllFieldsValidate = () => {
    const newValidState = isValidForm(
      this.state.labelDetails,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid;
  };

  setFilterParameters = (selected, drpIdentity) => {
    let details = this.state.labelDetails;
    details[drpIdentity] = selected.value;
    details.packing = selected.packing;
    details.itemName = selected.label;
    this.setState({ labelDetails: details }, () => {
      this.setState({ isAllowforPrintData: false });
    });
  };
  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.labelDetails;
    details[name] = value;
    this.setState({ labelDetails: details });
  };

  previewLabelPrinting = () => {
    let isAllFieldsValidate = this.isAllFieldsValidate();
    if (isAllFieldsValidate) {
      this.setState({ isLoading: true }, () => {
        if (Number(this.state.labelDetails.copy) > 0) {
          let printArray = this.state.labelDetails;
          const copies = printArray.copy || 0;
          const array = Array.from({ length: copies }, (_, index) => ({
            ...printArray,
            case: `${index + 1}/${copies}`,
          }));
          this.setState({ labelPrintingList: array, isLoading: false }, () => {
            this.printDiv()
          });
        }
      });
    }
  };

  printDiv = () => {
    const printContents = document.getElementById("printableArea").innerHTML;
    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;

    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload();
  };

  resetForm = () => {
    let validState = this.state.validState;
    validState.isValid = true;
    validState.error = {};
    let details = this.state.labelDetails
    details.itemId = ""
    details.itemName = ""
    details.packing = ""
    details.batchNo = ""
    details.mfgDate = ""
    details.expDate = ""
    details.mrp = ""
    details.quantity = ""
    details.copy = ""
    this.setState({ labelDetails: details, validState: validState });
  }

  handleChangeForDatePicker = (date, name) => {
    let details = this.state.labelDetails;
    details[name] = date;
    this.setState({ labelDetails: details });
  }

  render() {
    return (
      <>
        <div className="finishProductLabel-page">
          <div className="item-search">
            <div className="item-grp grid grid-cols-4 gap-2.5 mb-3">
              <div className="input-grp col-span-2">
                <label>Product Name</label>
                <MultiSelectDropdown
                  className={`  ${this.state.validState?.error?.itemId ? "errorInput" : ""}`}
                  drpIdentity="itemId"
                  options={this.state.companyItemList}
                  closeMenuOnSelect={true}
                  hideSelectedOptions={false}
                  onChange={(selected) =>
                    this.setFilterParameters(selected, "itemId", "labelDetails")
                  }
                  allowSelectAll={false}
                  value={this.state.companyItemList.filter(
                    (party) => party.value === this.state.labelDetails.itemId
                  )}
                />
                {/* <ValidationText error={this.state.validState.error.itemId} /> */}
              </div>
              <div className="input-grp">
                <label>Packing</label>
                <input
                  className={` inputFocus ${this.state.validState?.error?.packing ? "errorInput" : ""}`}
                  type="text"
                  id="packing"
                  name="packing"
                  autoComplete="off"
                  value={this.state.labelDetails.packing}
                  onChange={(event) => this.handleChange(event, "packing")}
                />
                {/* <ValidationText error={this.state.validState.error.packing} /> */}
              </div>
              <div className="input-grp">
                <label>Batch No.</label>
                <input
                  className={` inputFocus ${this.state.validState?.error?.batchNo ? "errorInput" : ""}`}
                  type="text"
                  id="batchNo"
                  name="batchNo"
                  autoComplete="off"
                  value={this.state.labelDetails.batchNo}
                  onChange={(event) => this.handleChange(event, "batchNo")}
                />
                {/* <ValidationText error={this.state.validState.error.batchNo} /> */}
              </div>
            </div>
            <div className="item-grp grid grid-cols-5 gap-2.5 mb-3.5">
              <div className="input-grp">
                <label>Mfg. Date</label>
                {/* <input
                  className={` inputFocus ${this.state.validState?.error?.mfgDate ? "errorInput" : ""}`}
                  type="date"
                  id="mfgDate"
                  name="mfgDate"
                  autoComplete="off"
                  value={this.state.labelDetails.mfgDate}
                  onChange={(event) => this.handleChange(event, "mfgDate")}
                /> */}
                <DatePicker
                  selected={this.state.labelDetails.mfgDate}
                  className={`inputFocus ${this.state.validState?.error?.mfgDate ? "errorInput" : ""}`}
                  dateFormat="MM/yyyy"
                  showMonthYearPicker
                  onChange={(date) => this.handleChangeForDatePicker(date, "mfgDate")}
                />
                {/* <ValidationText error={this.state.validState.error.mfgDate} /> */}
              </div>
              <div className="input-grp">
                <label>Exp. Date</label>
                {/* <input
                  className={` inputFocus ${this.state.validState?.error?.expDate ? "errorInput" : ""}`}
                  type="date"
                  id="expDate"
                  name="expDate"
                  autoComplete="off"
                  value={this.state.labelDetails.expDate}
                  onChange={(event) => this.handleChange(event, "expDate")}
                /> */}
                <DatePicker
                  selected={this.state.labelDetails.expDate}
                  className={`inputFocus ${this.state.validState?.error?.expDate ? "errorInput" : ""}`}
                  dateFormat="MM/yyyy"
                  showMonthYearPicker
                  onChange={(date) => this.handleChangeForDatePicker(date, "expDate")}
                />
                {/* <ValidationText error={this.state.validState.error.expDate} /> */}
              </div>
              <div className="input-grp">
                <label>
                  Quantity
                  <span className="text-sm font-medium ml-1.25">[Per box]</span>
                </label>
                <input
                  className={` inputFocus ${this.state.validState?.error?.quantity ? "errorInput" : ""}`}
                  type="number"
                  id="quantity"
                  name="quantity"
                  autoComplete="off"
                  value={this.state.labelDetails.quantity}
                  onChange={(event) => this.handleChange(event, "quantity")}
                />
                {/* <ValidationText error={this.state.validState.error.quantity} /> */}
              </div>
              <div className="input-grp">
                <label>M.R.P.</label>
                <input
                  className={` inputFocus ${this.state.validState?.error?.mrp ? "errorInput" : ""}`}
                  type="number"
                  id="mrp"
                  name="mrp"
                  autoComplete="off"
                  value={this.state.labelDetails.mrp}
                  onChange={(event) => this.handleChange(event, "mrp")}
                />
                {/* <ValidationText error={this.state.validState.error.mrp} /> */}
              </div>
              <div className="input-grp">
                <label>No of Copy</label>
                <input
                  className={` inputFocus ${this.state.validState?.error?.copy ? "errorInput" : ""}`}
                  type="number"
                  id="copy"
                  name="copy"
                  autoComplete="off"
                  value={this.state.labelDetails.copy}
                  onChange={(event) => this.handleChange(event, "copy")}
                />
                {/* <ValidationText error={this.state.validState.error.copy} /> */}
              </div>
            </div>
            <div className="btn-grp">
              <button
                className="print-btn h-fit"
                onClick={() => this.previewLabelPrinting()}
                disabled={this.state.isLoading}
              >
                {this.state.isLoading ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Print"}
              </button>
              <button
                className="cancel-btn h-fit"
                onClick={() => this.resetForm()}
                disabled={this.state.isLoading}
              >Cancel</button>
            </div>
          </div>
        </div>
        <div className=" hidden print:block print:bg-white" id="printableArea">
          <div
            className="grid grid-cols-2 print:grid-cols-2 w-full gap-2 px-5 print:gap-4 print:px-5 print:py-5 print:bg-white"
            id="printableArea"
          >
            {this.state.labelPrintingList &&
              this.state.labelPrintingList.length > 0 &&
              this.state.labelPrintingList.map((item, key) => (
                <div
                  key={key}
                  className="border-2 border-black p-3 break-inside-avoid print:break-inside-avoid"
                >
                  <p className="text-[20px] font-bold">{item.itemName}</p>
                  <table>
                    <tbody>
                      <tr>
                        <td className="!w-[30%] !pt-[2px] py-0 !text-[20px] font-semibold !border-none !px-0">Packing</td>
                        <td className="!pt-[2px] py-0 !text-[20px] font-semibold !border-none !px-0">: {item.packing}</td>
                      </tr>
                      <tr>
                        <td className="!w-[30%] !pt-[2px] py-0 !text-[20px] font-semibold !border-none !px-0">Batch No</td>
                        <td className="!pt-[2px] py-0 !text-[20px] font-semibold !border-none !px-0">: {item.batchNo}</td>
                      </tr>
                      <tr>
                        <td className="!w-[30%] !pt-[2px] py-0 !text-[20px] font-semibold !border-none !px-0">Mfg.Date</td>
                        <td className="!pt-[2px] py-0 !text-[20px] font-semibold !border-none !px-0">: {moment(item.mfgDate).format('MM/YYYY')}</td>
                      </tr>
                      <tr>
                        <td className="!w-[30%] !pt-[2px] py-0 !text-[20px] font-semibold !border-none !px-0">Exp.Date</td>
                        <td className="!pt-[2px] py-0 !text-[20px] font-semibold !border-none !px-0">: {moment(item.expDate).format('MM/YYYY')}</td>
                      </tr>
                      <tr>
                        <td className="!w-[30%] !pt-[2px] py-0 !text-[20px] font-semibold !border-none !px-0">M.R.P.</td>
                        <td className="!pt-[2px] py-0 !text-[20px] font-semibold !border-none !px-0">: {item.mrp}</td>
                      </tr>
                      {/* <tr>
                        <td className="!w-[30%] !pt-[2px] py-0 !text-[20px] font-semibold !border-none !px-0">Quantity</td>
                        <td className="!pt-[2px] py-0 !text-[20px] font-semibold !border-none !px-0">: {item.quantity}</td>
                      </tr> */}
                      <tr>
                        <td className="!w-[30%] !pt-[2px] py-0 !text-[20px] font-semibold !border-none !px-0">Case</td>
                        <td className="!pt-[2px] py-0 !text-[20px] font-semibold !border-none !px-0">: {item.case}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ))}
          </div>
        </div>
      </>
    );
  }
}

export default FinishProductLabelPrinting;
